// extracted by mini-css-extract-plugin
module.exports = {"passwordValidator":"ConfirmStaffAccountForm_passwordValidator__1SeAv","confirmAccountCTA":"ConfirmStaffAccountForm_confirmAccountCTA__1HtAL"};